/**
 * Sáu tab của màn "Gói & thanh toán" (`/admin/goi-thanh-toan`), mỗi tab một quyền đọc.
 *
 * Màn gom bốn mục điều hướng cũ: Gói dịch vụ (kèm danh mục dịch vụ, ADR-0019), Gói tài nguyên — nay gọi "Gói hạn
 * mức" (ADR-0091 mục 1), Giá AI — nay "Bảng giá model" (ADR-0095 mục 10), và hàng chờ yêu cầu token AI — nay "Yêu cầu
 * nạp token" (ADR-0091 mục 3). Quyền của từng tab giữ đúng quyền của mục cũ, nên không ai thấy nhiều hơn trước.
 *
 * Luật chọn tab là hàm thuần để kiểm được bằng test; view chỉ nối quyền trong phiên vào.
 */

export const TAB_GOI_THANH_TOAN = [
  'goi-dich-vu',
  'danh-muc-dich-vu',
  'goi-han-muc',
  'goi-nap-token',
  'bang-gia-model',
  'yeu-cau-nap-token',
] as const;

export type TabGoiThanhToan = (typeof TAB_GOI_THANH_TOAN)[number];

/** Tên tham số URL giữ tab đang mở. Giá trị là khoá tab ở trên. */
export const THAM_SO_TAB = 'tab';

/** Quyền đọc cần có để thấy từng tab (ADR-UI-0005: không có quyền thì ẩn tab, không hiện mờ). */
export const QUYEN_TAB: Readonly<Record<TabGoiThanhToan, string>> = {
  'goi-dich-vu': 'GOI.READ',
  'danh-muc-dich-vu': 'GOI.READ',
  'goi-han-muc': 'PLATFORM_POLICY.READ',
  // Gói nạp token là danh mục của nền tảng như gói hạn mức, cùng chỗ chỉnh (chính sách nền tảng).
  'goi-nap-token': 'PLATFORM_POLICY.READ',
  'bang-gia-model': 'AI_PRICING.READ',
  'yeu-cau-nap-token': 'TENANT.READ',
};

/** Quyền của mục điều hướng: có một trong số này là thấy màn (registry `app/modules.ts`). */
export const QUYEN_GOI_THANH_TOAN: readonly string[] = [...new Set(Object.values(QUYEN_TAB))];

/** Các tab người xem mở được, theo thứ tự hiển thị. */
export function cacTab(duoc: (ma: string) => boolean): TabGoiThanhToan[] {
  return TAB_GOI_THANH_TOAN.filter((k) => duoc(QUYEN_TAB[k]));
}

export function laTab(gt: string | null | undefined): gt is TabGoiThanhToan {
  return gt !== null && gt !== undefined && (TAB_GOI_THANH_TOAN as readonly string[]).includes(gt);
}

/** Tab mở lúc vào màn: `?tab=` nếu hợp lệ và được phép, không thì tab đầu người này mở được. */
export function tabMacDinh(thamSo: URLSearchParams, coTab: readonly TabGoiThanhToan[]): TabGoiThanhToan | undefined {
  const xin = thamSo.get(THAM_SO_TAB);
  return laTab(xin) && coTab.includes(xin) ? xin : coTab[0];
}
